import { useSpinnerStore } from '@/stores/spinner'

// $spinner is the app-wide handle every page uses to raise/lower the global
// loading overlay. It sits on top of the reference-counted spinner store and
// adds two safety behaviours:
//
//   * MIN_DISPLAY — keep the overlay up briefly so it doesn't flicker.
//   * WATCHDOG    — each show() gets a timer; if its matching hide() never
//                   arrives (an error path skipped it), the timer auto-releases
//                   that one increment. A leaked spinner can no longer freeze
//                   the whole app behind the full-screen overlay — the worst
//                   case is a spinner that self-clears after WATCHDOG_MS.
export default {
  install(Vue) {
    const spinner = useSpinnerStore()
    const MIN_DISPLAY = 300 // min ms the overlay stays visible (anti-flicker)
    const WATCHDOG_MS = 20000 // max ms a single show() may hold a count

    // FIFO of pending watchdog timers — one per not-yet-matched show().
    const watchdogs = []
    let lastShowTs = 0

    const releaseWatchdog = () => {
      const t = watchdogs.shift()
      if (t) clearTimeout(t)
    }

    Vue.prototype.$spinner = {
      show() {
        spinner.show()
        lastShowTs = Date.now()
        const t = setTimeout(() => {
          // This show() was never matched by a hide() within the watchdog
          // window — release the increment so the overlay can't block clicks
          // forever.
          const idx = watchdogs.indexOf(t)
          if (idx !== -1) watchdogs.splice(idx, 1)
          spinner.hide()
        }, WATCHDOG_MS)
        watchdogs.push(t)
      },
      hide() {
        // A real hide() arrived — cancel one pending watchdog so it doesn't
        // later double-decrement.
        releaseWatchdog()
        const elapsed = Date.now() - lastShowTs
        if (elapsed >= MIN_DISPLAY) {
          spinner.hide()
        } else {
          setTimeout(() => spinner.hide(), MIN_DISPLAY - elapsed)
        }
      },
    }
  },
}
